module.exports = __webpack_public_path__ + "static/media/advantages_2.11be7cbf.svg";